import { FeatureFlagServicePromiseClient } from '@taxfyle/api-internal/internal/feature_flag_grpc_web_pb'
import {
  CreateSegmentUserRequest,
  DeleteSegmentUserRequest,
} from '@taxfyle/api-internal/internal/feature_flag_pb'
import { createGrpcAuthenticator } from 'infra/grpc-authenticator'
import memoize from 'memoizee'
import { APIConfig } from 'types/definitions'
import { enableDevTools } from 'utils/grpc-util'

/**
 * Creates an instance of the Feature Flags API.
 *
 * @param config
 */
export function createFeatureFlagsAPI(config: APIConfig) {
  return new FeatureFlagsAPI(config)
}

export class FeatureFlagsAPI {
  private readonly featureFlagsClient = createFeatureFlagsClient(
    this.config.baseURL,
  )

  private readonly grpcAuthenticator = createGrpcAuthenticator(this.config)

  /**
   * Constructor.
   *
   * @param config
   */
  constructor(private config: APIConfig) {}

  /**
   *
   * @param request
   */
  async addUserToSegment(request: CreateSegmentUserRequest) {
    return this.featureFlagsClient.createSegmentUser(
      request,
      await this.grpcAuthenticator.getMeta(),
    )
  }

  /**
   *
   * @param request
   */
  async deleteUserFromSegment(request: DeleteSegmentUserRequest) {
    return this.featureFlagsClient.deleteSegmentUser(
      request,
      await this.grpcAuthenticator.getMeta(),
    )
  }
}

const createFeatureFlagsClient = memoize(function createFeatureFlagsGrpcClient(
  baseUrl: string,
) {
  const client = new FeatureFlagServicePromiseClient(baseUrl)
  enableDevTools(client)
  return client
})
